module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.canAddInvoice) ? _c('b-button', {
    attrs: {
      "id": "show-btn",
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.addInvoice
    }
  }, [_vm._v("\n    Add Invoice "), _c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.invoiceList), function(invoice, index) {
    return _c('b-card', {
      key: 'invoice-' + index,
      staticClass: "mt-2"
    }, [(index != 0) ? _c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('b-button', {
      staticClass: "ml-auto",
      attrs: {
        "disabled": _vm.isInvoiceRemovable(invoice),
        "id": "show-btn",
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          _vm.removeInvoice(index)
        }
      }
    }, [_vm._v("\n        Remove Invoice "), _c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1) : _vm._e(), _vm._v(" "), (_vm.showRemoveSingleButton && _vm.moduleDetail.allModuleId && _vm.paymentDetail.paymentId) ? _c('RemoveSlineInvoiceButton', {
      attrs: {
        "BTNTitle": 'Remove Single Invoice',
        "Type": 'Single',
        "SlineType": _vm.config.slineType,
        "TransportType": _vm.config.transportType,
        "SlinePayId": _vm.paymentDetail.paymentId,
        "SlineInvId": invoice.invoiceId,
        "allModuleId": _vm.moduleDetail.allModuleId
      },
      on: {
        "refresh-data": function($event) {
          _vm.$emit('refresh-data')
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.showRevisedMailCheckbox) ? _c('div', {
      staticClass: "mt-2"
    }, [_c('input', {
      attrs: {
        "disabled": _vm.isRevisedInvoiceDisabled(invoice),
        "id": 'checkbox-' + index,
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.toggleRevisedInvoice(index, 'checkbox-' + index)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "error"
    }, [_vm._v("Revise Invoice")])]) : _vm._e(), _vm._v(" "), _c('b-row', {
      attrs: {
        "align-v": "start"
      }
    }, [_c('b-col', {
      attrs: {
        "cols": _vm.getColumnSize('category')
      }
    }, [_c('label', [_vm._v("Invoice Category"), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-radio-group', {
      staticClass: "mb-3",
      attrs: {
        "options": _vm.config.invCategoryList,
        "value-field": "payVal",
        "text-field": "payText",
        "disabled-field": "notEnabled"
      },
      model: {
        value: (invoice.invCategory),
        callback: function($$v) {
          _vm.$set(invoice, "invCategory", $$v)
        },
        expression: "invoice.invCategory"
      }
    }), _vm._v(" "), (invoice.invCategory_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v("\n          " + _vm._s(invoice.invCategory_err) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": _vm.getColumnSize('number')
      }
    }, [_c('label', [_vm._v("Invoice No"), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": _vm.isInvoiceDisabled(invoice),
        "name": "invoiceNo"
      },
      on: {
        "input": function($event) {
          _vm.clearFieldError(invoice, 'invNo')
        }
      },
      model: {
        value: (invoice.invNo),
        callback: function($$v) {
          _vm.$set(invoice, "invNo", $$v)
        },
        expression: "invoice.invNo"
      }
    }), _vm._v(" "), (invoice.invNo_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v("\n          " + _vm._s(invoice.invNo_err) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": _vm.getColumnSize('type')
      }
    }, [_c('label', [_vm._v("Invoice Type"), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('CustomMultiSelect', {
      attrs: {
        "disabled": _vm.isInvoiceDisabled(invoice),
        "options": _vm.config.invoiceTypeList,
        "selected-options": invoice.invType,
        "placeholder": "Select Type",
        "multiple": true,
        "error-class": _vm.getErrorClass(invoice, 'invType')
      },
      on: {
        "select": function($event) {
          _vm.onInvoiceTypeSelect($event, invoice, index)
        }
      },
      model: {
        value: (invoice.invType),
        callback: function($$v) {
          _vm.$set(invoice, "invType", $$v)
        },
        expression: "invoice.invType"
      }
    }), _vm._v(" "), (invoice.invType_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v("\n          " + _vm._s(invoice.invType_err) + "\n        ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', {
      attrs: {
        "align-v": "start"
      }
    }, [_c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('label', [_vm._v("Invoice Date"), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('date-picker', {
      attrs: {
        "format": _vm.selectDateFormat,
        "lang": "en",
        "name": "inv_date",
        "id": "inv_date",
        "minute-step": 1
      },
      on: {
        "input": function($event) {
          _vm.clearFieldError(invoice, 'inv_date')
        }
      },
      model: {
        value: (invoice.inv_date),
        callback: function($$v) {
          _vm.$set(invoice, "inv_date", $$v)
        },
        expression: "invoice.inv_date"
      }
    }), _vm._v(" "), (invoice.inv_date_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v("\n          " + _vm._s(invoice.inv_date_err) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "4"
      }
    }, [_c('label', [_vm._v("Shipping Line Invoice (Drag & Drop)"), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('multi-file-uploader', {
      style: ('height: 79px; background: darkgray; width: 200px;'),
      attrs: {
        "disabled": _vm.isInvoiceDisabled(invoice) || invoice.enableDisable,
        "index": 0,
        "second_index": index,
        "documentName": _vm.config.documentName,
        "otherDocName": _vm.config.otherDocName,
        "folderName": 'Sline_Invoice',
        "accept": '*',
        "assign_no": _vm.getAssignmentNumber(),
        "multiple": true,
        "state": Boolean(invoice.invSlineUpload),
        "fileAllModuleId": _vm.paymentDetail.allModuleId
      },
      model: {
        value: (invoice.invSlineUpload),
        callback: function($$v) {
          _vm.$set(invoice, "invSlineUpload", $$v)
        },
        expression: "invoice.invSlineUpload"
      }
    }), _vm._v(" "), (invoice.invSlineUpload_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v("\n          " + _vm._s(invoice.invSlineUpload_err) + "\n        ")]) : _vm._e(), _vm._v(" "), (invoice.invSlineUpload && invoice.invSlineUpload) ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.openSignedDocument(("ASSIGNMENT_UPLOADS/" + (_vm.getAssignmentNumber().replaceAll('/', '_')) + "/" + (invoice.invSlineUpload)))
        }
      }
    }, [_vm._v("\n          --View\n        ")]) : _vm._e()], 1)], 1), _vm._v(" "), (invoice.invCategory == 'Supplementary') ? _c('div', {
      staticClass: "row mt-2"
    }, [_c('div', {
      staticClass: "col-md-4 row"
    }, [_c('label', {
      staticClass: "col-md-4"
    }, [_vm._v("Bill to Shipper : "), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_c('b-form-radio-group', {
      staticClass: "mb-3",
      attrs: {
        "options": _vm.config.scCategoryList,
        "value-field": "SCVal",
        "text-field": "SCText"
      },
      on: {
        "input": function($event) {
          _vm.changeSCCategory(invoice, index)
        }
      },
      model: {
        value: (invoice.scCategory),
        callback: function($$v) {
          _vm.$set(invoice, "scCategory", $$v)
        },
        expression: "invoice.scCategory"
      }
    }), _vm._v(" "), (_vm.showSCCategoryError(invoice)) ? _c('span', {
      staticClass: "error"
    }, [_vm._v("\n            " + _vm._s(invoice.scCategory_err) + "\n          ")]) : _vm._e()], 1)]), _vm._v(" "), (invoice.scCategory == 'Yes' || invoice.scCategory == 'No') ? _c('div', {
      staticClass: "col-md-4 row"
    }, [_c('label', {
      staticClass: "col-md-3"
    }, [_vm._v("Remark : "), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-9"
    }, [_c('b-form-textarea', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "id": "remark",
        "name": "remark"
      },
      model: {
        value: (invoice.scremark),
        callback: function($$v) {
          _vm.$set(invoice, "scremark", $$v)
        },
        expression: "invoice.scremark"
      }
    }), _vm._v(" "), (_vm.showSCRemarkError(invoice)) ? _c('span', {
      staticClass: "error"
    }, [_vm._v("\n            Bill to Shipper Remark Field is Required\n          ")]) : _vm._e()], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((invoice.invCurrencyList), function(currency, currIndex) {
      return _c('b-card', {
        key: 'currency-' + index + '-' + currIndex,
        staticClass: "mt-2"
      }, [(currIndex != 0) ? _c('b-row', [_c('b-col', [_c('div', {
        staticClass: "d-flex align-items-center mt-3"
      }, [_c('b-button', {
        staticClass: "ml-auto",
        attrs: {
          "id": "show-btn",
          "size": "sm",
          "variant": "outline-danger"
        },
        on: {
          "click": function($event) {
            _vm.removeInvoiceCurrency(index, currIndex)
          }
        }
      }, [_vm._v("\n              REMOVE AMOUNT\n              "), _c('i', {
        staticClass: "fa fa-plus",
        attrs: {
          "aria-hidden": "true"
        }
      })])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('b-row', [_c('b-col', {
        attrs: {
          "cols": "3"
        }
      }, [_c('label', [_vm._v("Invoice Amount"), _c('span', {
        staticClass: "error"
      }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
        attrs: {
          "formatter": _vm.capitalizeAll,
          "disabled": _vm.isAmountDisabled(invoice, currency),
          "name": "invoiceAmount",
          "type": "number"
        },
        on: {
          "input": function($event) {
            _vm.clearCurrencyFieldError(currency, 'invAmount')
          }
        },
        model: {
          value: (currency.invAmount),
          callback: function($$v) {
            _vm.$set(currency, "invAmount", $$v)
          },
          expression: "currency.invAmount"
        }
      }), _vm._v(" "), (currency.invAmount_err) ? _c('span', {
        staticClass: "error"
      }, [_vm._v("\n              " + _vm._s(currency.invAmount_err) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
        attrs: {
          "cols": "3"
        }
      }, [_c('label', [_vm._v("Currency"), _c('span', {
        staticClass: "error"
      }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
        attrs: {
          "isDisabled": _vm.isAmountDisabled(invoice, currency),
          "list": _vm.config.currList,
          "option-value": "payVal",
          "option-text": "payText",
          "placeholder": "Select Currency"
        },
        on: {
          "input": function($event) {
            _vm.clearCurrencyFieldError(currency, 'invCurrency')
          }
        },
        model: {
          value: (currency.invCurrency),
          callback: function($$v) {
            _vm.$set(currency, "invCurrency", $$v)
          },
          expression: "currency.invCurrency"
        }
      }), _vm._v(" "), (currency.invCurrency_err) ? _c('span', {
        staticClass: "error"
      }, [_vm._v("\n              " + _vm._s(currency.invCurrency_err) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), (_vm.showPaymentFields) ? _c('b-col', [_c('label', [_vm._v("Payment Mode")]), _vm._v(" "), _c('model-list-select', {
        attrs: {
          "isDisabled": _vm.isPaymentModeDisabled(currency),
          "list": _vm.config.payList,
          "option-value": "payVal",
          "option-text": "payText",
          "placeholder": "Select Mode"
        },
        model: {
          value: (currency.invPayMode),
          callback: function($$v) {
            _vm.$set(currency, "invPayMode", $$v)
          },
          expression: "currency.invPayMode"
        }
      }), _vm._v(" "), (currency.invPayMode_err) ? _c('span', {
        staticClass: "error"
      }, [_vm._v("\n              " + _vm._s(currency.invPayMode_err) + "\n            ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showPaymentFields) ? _c('b-col', [_c('label', [_vm._v("Payment Ref")]), _vm._v(" "), _c('b-form-input', {
        attrs: {
          "disabled": _vm.isPaymentRefDisabled(currency),
          "formatter": _vm.capitalizeAll,
          "name": "paymentRef"
        },
        on: {
          "input": function($event) {
            _vm.changeDisableButton(currency.invPayRef)
          }
        },
        model: {
          value: (currency.invPayRef),
          callback: function($$v) {
            _vm.$set(currency, "invPayRef", $$v)
          },
          expression: "currency.invPayRef"
        }
      }), _vm._v(" "), (currency.invPayRef_err) ? _c('span', {
        staticClass: "error"
      }, [_vm._v("\n              " + _vm._s(currency.invPayRef_err) + "\n            ")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.showPaymentFields) ? _c('b-row', [_c('b-col', {
        attrs: {
          "cols": "4"
        }
      }, [_c('label', [_vm._v("Payment Amount")]), _vm._v(" "), _c('b-form-input', {
        attrs: {
          "disabled": _vm.isPaymentAmountDisabled(currency),
          "formatter": _vm.capitalizeAll,
          "name": "paymentAmount"
        },
        model: {
          value: (currency.invPaidAmount),
          callback: function($$v) {
            _vm.$set(currency, "invPaidAmount", $$v)
          },
          expression: "currency.invPaidAmount"
        }
      }), _vm._v(" "), (currency.invPaidAmount_err) ? _c('span', {
        staticClass: "error"
      }, [_vm._v("\n              " + _vm._s(currency.invPaidAmount_err) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
        staticClass: "mt-4",
        attrs: {
          "cols": "4"
        }
      }, [_c('label', [_vm._v("Payment Date")]), _vm._v(" "), _c('date-picker', {
        attrs: {
          "disabled": _vm.isPaymentDateDisabled(currency),
          "format": _vm.selectDateFormat,
          "lang": "en",
          "name": "paymentDate",
          "minute-step": 1
        },
        on: {
          "input": function($event) {
            _vm.changeDisableButton(currency.invPayDate)
          }
        },
        model: {
          value: (currency.invPayDate),
          callback: function($$v) {
            _vm.$set(currency, "invPayDate", $$v)
          },
          expression: "currency.invPayDate"
        }
      }), _vm._v(" "), (currency.invPayDate_err) ? _c('span', {
        staticClass: "error"
      }, [_vm._v("\n              " + _vm._s(currency.invPayDate_err) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
        attrs: {
          "cols": "4"
        }
      }, [_c('label', [_vm._v("Payment Status")]), _vm._v(" "), _c('model-list-select', {
        attrs: {
          "isDisabled": _vm.isPaymentStatusDisabled(currency),
          "list": _vm.config.statusList,
          "option-value": "payVal",
          "option-text": "payText",
          "placeholder": "Select Status"
        },
        model: {
          value: (currency.invPayStatus),
          callback: function($$v) {
            _vm.$set(currency, "invPayStatus", $$v)
          },
          expression: "currency.invPayStatus"
        }
      }), _vm._v(" "), (currency.invPayStatus_err) ? _c('span', {
        staticClass: "error"
      }, [_vm._v("\n              " + _vm._s(currency.invPayStatus_err) + "\n            ")]) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)
    })], 2)
  }), _vm._v(" "), (_vm.invoiceList.length > 0) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "disabled": _vm.isSaveDisabled,
      "variant": "primary",
      "id": "addButtonLoaderSB"
    },
    on: {
      "click": _vm.saveAndSubmit
    }
  }, [_vm._v("\n        Save & Submit\n      ")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderSB"
    }
  })], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0017bb27","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/InvoiceManagementComponent.vue
// module id = 2346
// module chunks = 0